<template>
  <el-form ref="postForm" :model="postForm">
    <el-form-item v-if=" type=='date' " label="原时间">
      {{ lastData }}
    </el-form-item>
    <el-form-item v-if=" type=='cost' " label="原金额">
      {{ lastData/100 }}元
    </el-form-item>
    <el-form-item v-if=" type=='date' " label="修改的时间">
      <el-date-picker v-model="postForm.begin_day" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
    </el-form-item>
    <el-form-item v-if=" type=='cost' " label="修改的金额">
      <el-input-number v-model="postForm.cost" :precision="2" :step="1" :max="100000" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="fnHandleSave()">确认修改</el-button>
    </el-form-item>
  </el-form>
</template>
<script>

const defaultForm = {
  id: '',
  begin_day: '',
  cost: ''// 单位元
}

export default {
  name: 'SetActiveInfo',
  props: {
    activityId: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'date'
    },
    lastData: {
      type: String,
      default: 'date'
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm)
    }
  },
  created() {
    if (this.activityId) {
      this.postForm.id = this.activityId
    }
  },
  methods: {
    fnHandleDate() {
      if (this.postForm.begin_day == '') {
        this.$message.error('请填写修改时间')
        return
      }
      this.$http.updateActivityBeginDay(this.postForm).then(res => {
        if (res.code == 200) {
          this.$message.success('修改成功')
          this.postForm.begin_day = ''
          this.$emit('successCBK')
        }
      })
    },
    fnHandleCost() {
      if (this.postForm.cost == '') {
        this.$message.error('请填写成本金额')
        return
      }
      this.$http.updateActivityCost(this.postForm).then(res => {
        if (res.code == 200) {
          this.$message.success('修改成功')
          this.postForm.cost = ''
          this.$emit('successCBK')
        }
      })
    },
    fnHandleSave: function() {
      switch (this.type) {
        case 'date' :
          this.fnHandleDate()
          break
        case 'cost' :
          this.fnHandleCost()
          break
        default:
          break
      }
    }
  }
}
</script>
  <style lang="scss" scope>

  .combo-group {
    .tuolele-main-search {
      .el-button {
        margin-left:0px!important
      }
      .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
        padding-left: 20px !important;
      }
      .el-tabs--top .el-tabs__item.is-top:last-child {
        padding-right: 20px !important;
      }
      .el-form-item__label {
        font-size: 16px;
        color: #333;
      }
      .el-form-item__content {
        margin: 0 20px 0 12px;
      }
    }
  }
  </style>
